import React from "react";
import Users from "@/pages/Users";

/** Team & Roles already has a complete, working implementation (invites,
 * role management, session list) at `@/pages/Users` — reused here as-is
 * rather than rebuilt, per the licensing plan's "reuse existing
 * infrastructure" principle. The page is self-contained (fetches its
 * own data, no dependency on the old Layout chrome), so it drops
 * straight into the Portal shell. */
export default function PortalTeam() {
    return <Users />;
}
